/* Desplegable con el estilo de la web para <select data-pk-select>.
   El <select> nativo sigue en el formulario (es el que se envía) y recibe cada cambio
   con un evento «change». Patrón ARIA: botón + listbox, con teclado completo.
   En pantallas táctiles se deja el selector nativo del sistema, que ahí es mejor. */
(() => {
  if (!window.matchMedia('(pointer: fine)').matches) return;
  let uid = 0;

  const enhance = (select) => {
    if (select.dataset.pkSelectReady) return;
    select.dataset.pkSelectReady = '1';
    const n = ++uid;
    const label = document.querySelector(`label[for="${select.id}"]`);
    const wrap = document.createElement('div');
    wrap.className = 'pk-select';
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pk-select__btn';
    btn.id = `pk-select-btn-${n}`;
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span class="pk-select__value"></span><svg class="pk-select__chev" viewBox="0 0 16 10" aria-hidden="true"><path d="M1 1l7 7 7-7" fill="none" stroke="currentColor" stroke-width="2"/></svg>';
    const list = document.createElement('ul');
    list.className = 'pk-select__list';
    list.id = `pk-select-list-${n}`;
    list.setAttribute('role', 'listbox');
    list.tabIndex = -1;
    list.hidden = true;
    btn.setAttribute('aria-controls', list.id);
    if (label) {
      label.id = label.id || `pk-select-label-${n}`;
      label.htmlFor = btn.id;
      btn.setAttribute('aria-labelledby', `${label.id} ${btn.id}`);
      list.setAttribute('aria-labelledby', label.id);
    }

    const options = [];
    [...select.children].forEach((child) => {
      const add = (opt) => {
        if (opt.value === '' && opt === select.options[0]) return; // «Elegí…» no es una opción real
        const li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.id = `pk-select-${n}-${options.length}`;
        li.className = 'pk-select__opt' + (opt.value === '' ? ' is-placeholder' : '');
        li.textContent = opt.textContent;
        li.dataset.value = opt.value;
        list.appendChild(li);
        options.push(li);
      };
      if (child.tagName === 'OPTGROUP') {
        const g = document.createElement('li');
        g.setAttribute('role', 'presentation');
        g.className = 'pk-select__group';
        g.textContent = child.label;
        list.appendChild(g);
        [...child.children].forEach(add);
      } else add(child);
    });

    let active = -1;
    const value = btn.querySelector('.pk-select__value');
    const sync = () => {
      const opt = select.options[select.selectedIndex];
      options.forEach((o) => o.setAttribute('aria-selected', String(!!opt && opt.value !== '' && o.dataset.value === opt.value)));
      value.textContent = opt ? opt.textContent : '';
      wrap.classList.toggle('is-empty', select.value === '');
    };
    const setActive = (i) => {
      active = Math.max(0, Math.min(options.length - 1, i));
      options.forEach((o, k) => o.classList.toggle('is-active', k === active));
      list.setAttribute('aria-activedescendant', options[active].id);
      options[active].scrollIntoView({ block: 'nearest' });
    };
    const open = () => {
      if (!list.hidden) return;
      list.hidden = false;
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      const below = window.innerHeight - btn.getBoundingClientRect().bottom;
      wrap.classList.toggle('is-up', below < 280 && btn.getBoundingClientRect().top > below);
      setActive(Math.max(options.findIndex((o) => o.getAttribute('aria-selected') === 'true'), 0));
      list.focus({ preventScroll: true });
    };
    const close = (refocus = true) => {
      if (list.hidden) return;
      list.hidden = true;
      wrap.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      if (refocus) btn.focus();
    };
    const choose = (i) => {
      const v = options[i].dataset.value;
      if (select.value !== v) {
        select.value = v;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      sync();
      close();
    };

    btn.addEventListener('click', () => (list.hidden ? open() : close()));
    btn.addEventListener('keydown', (e) => {
      if (['ArrowDown', 'ArrowUp', 'Enter', ' '].includes(e.key)) { e.preventDefault(); open(); }
    });
    list.addEventListener('click', (e) => {
      const li = e.target.closest('[role="option"]');
      if (li) choose(options.indexOf(li));
    });
    list.addEventListener('mousemove', (e) => {
      const li = e.target.closest('[role="option"]');
      if (li && options.indexOf(li) !== active) setActive(options.indexOf(li));
    });
    let typed = '';
    let typedTimer;
    list.addEventListener('keydown', (e) => {
      switch (e.key) {
        case 'ArrowDown': e.preventDefault(); setActive(active + 1); break;
        case 'ArrowUp': e.preventDefault(); setActive(active - 1); break;
        case 'Home': e.preventDefault(); setActive(0); break;
        case 'End': e.preventDefault(); setActive(options.length - 1); break;
        case 'Enter': case ' ': e.preventDefault(); choose(active); break;
        case 'Escape': e.preventDefault(); close(); break;
        case 'Tab': close(false); break;
        default:
          if (e.key.length === 1) {
            typed += e.key.toLowerCase();
            clearTimeout(typedTimer);
            typedTimer = setTimeout(() => { typed = ''; }, 600);
            const hit = options.findIndex((o) => o.textContent.toLowerCase().startsWith(typed));
            if (hit > -1) setActive(hit);
          }
      }
    });
    list.addEventListener('focusout', (e) => { if (!wrap.contains(e.relatedTarget)) close(false); });
    document.addEventListener('pointerdown', (e) => { if (!wrap.contains(e.target)) close(false); });
    select.addEventListener('change', sync);

    select.classList.add('pk-select__native');
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');
    select.parentNode.insertBefore(wrap, select);
    wrap.append(btn, list, select);
    sync();
  };

  const run = () => document.querySelectorAll('select[data-pk-select]').forEach(enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  // la ficha reemplaza su HTML al cambiar de variante (pk-product.js): mejorar los selects nuevos
  document.addEventListener('pk:product-updated', run);
})();
